import type { FormSchema } from '@cli-types/core-engine/schema.js'

export function isMultiStepForm(schema: FormSchema): boolean {
  return Array.isArray(schema.steps) && schema.steps.length > 0
}
